import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';
import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import ShareIcon from '@material-ui/icons/Share';
import React from 'react';
import { Link } from 'react-router-dom';
import Box from './index';
export default function Meta({ id }) {
	const classes = useStyles();
	return (
		<Box display="flex" flexDirection="row">
			<Button variant="contained" color="default" startIcon={<GetAppIcon />} className={classes.button}>
				Export
			</Button>
			<Button variant="contained" color="default" startIcon={<ShareIcon />} className={classes.button}>
				Share
			</Button>
			<Button variant="contained" color="default" startIcon={<PrintIcon />} className={classes.button}>
				Print
			</Button>
			<Button
				variant="contained"
				color="primary"
				startIcon={<EmailIcon />}
				component={Link}
				to={`/market-search/${id}/letter-of-intent`}
			>
				Loi
			</Button>
		</Box>
	);
}

const useStyles = makeStyles(theme => ({
	button: {
		marginRight: '1rem',
	},
}));
